import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"40\" height=\"40\" x=\"1\" y=\"1\" fill=\"#EAF3FE\" stroke=\"#4893F4\" stroke-dasharray=\"8.62 1.72\" stroke-width=\"1.5\" rx=\"20\"></rect><circle cx=\"21\" cy=\"11\" r=\"2\" stroke=\"#4893F4\" stroke-width=\"1.5\"></circle><circle cx=\"11\" cy=\"21\" r=\"2\" stroke=\"#4893F4\" stroke-width=\"1.5\"></circle><circle cx=\"22\" cy=\"22\" r=\"3\" fill=\"#4893F4\" stroke=\"#4893F4\" stroke-width=\"1.5\"></circle><circle cx=\"32\" cy=\"21\" r=\"2\" stroke=\"#4893F4\" stroke-width=\"1.5\"></circle><circle cx=\"21\" cy=\"32\" r=\"2\" stroke=\"#4893F4\" stroke-width=\"1.5\"></circle><path stroke=\"#4893F4\" d=\"M22 18v-5m0 8h8m-8 1v8m-1-9h-8\"></path>", 7)
  ]))]))
}
export default { render: render }